import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import {
  AbsolutePositionAligner,
  IosArrowDown,
  Menu,
  MenuItem,
  useDocumentEvent,
} from '@sgcmpteltd/uikit-react';
import {
  DOCUMENT_EVENT_NAME_CLICK,
} from '@sgcmpteltd/uikit-react/hooks/use-document-event';
import {
  alignBottomXBegin,
  alignBottomXEnd,
} from '@sgcmpteltd/uikit-react/utils/position/fixed';
import cx from 'clsx';
import { useRef, useState } from 'react';

import { sortMenuItemsConfig } from './configs';
import { ARROW_ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';
import { isSortOrder } from './utils';

export const SortSelect: Component = ({
  sorter,
  isSearchPending,
  onSortChange,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const onDocMouseClickRef = useRef<Document['onclick'] | null>(null);
  const { isDesktop, isDesktopLarge } = useScreenDetect();

  onDocMouseClickRef.current = ({ target }) => {
    if (
      target instanceof Element
      && (target.closest(`.${styles.sortButton}`) || target.closest(`.${styles.iconArrow}`))
    ) {
      return;
    }
    setIsMenuOpen(false);
  };

  useDocumentEvent({
    eventName: DOCUMENT_EVENT_NAME_CLICK,
    eventHandlerRef: onDocMouseClickRef,
  });

  const handleSortClick = () => {
    setIsMenuOpen(prev => !prev);
  };

  const handleMenuItemClick = (value?: string | number) => {
    if (isSortOrder(value)) {
      onSortChange?.({
        value,
        isChecked: true,
      });
    }

    setIsMenuOpen(false);
  };

  return (
    <div className={styles.containerRoot}>
      <span className={styles.textSortBy}>Sort by</span>
      <AbsolutePositionAligner
        autoLocate={false}
        isActive={isMenuOpen}
        offset={{ top: 20, left: isDesktopLarge() ? -100 : -25 }}
        rectCalculator={isDesktop() ? alignBottomXEnd : alignBottomXBegin}
        targetElement={(
          <Menu className={cx(
            styles.menuRoot,
            styles.isBorderRadius,
          )}>
            {sortMenuItemsConfig.map(v => (
              <MenuItem
                key={v.value}
                isActive={sorter === v.value}
                value={v.value}
                onClick={handleMenuItemClick}>
                {v.text}
              </MenuItem>
            ))}
          </Menu>
        )}
        targetElementClassName={styles.containerMenu}>
        <button
          aria-label="sort"
          className={styles.sortButton}
          disabled={isSearchPending}
          type="button"
          onClick={handleSortClick}>
          {sortMenuItemsConfig.find(
            config => config.value === sorter,
          )?.text}
        </button>
      </AbsolutePositionAligner>
      <button
        aria-label="ios arrow down"
        className={styles.iconArrowButton}
        type="button"
        onClick={handleSortClick}>
        <IosArrowDown
          className={cx(
            styles.iconArrow,
            isMenuOpen && styles.isOpen,
          )}
          size={ARROW_ICON_SIZE} />
      </button>
    </div>
  );
};
